module.exports = __webpack_public_path__ + "img/clound.4dcd85b6.png";